import React from "react"
import {observer} from "mobx-react"
import {injectIntl} from "react-intl"

import {Container, Grid} from "@material-ui/core"

function XsFooter() {
	return (
		<div className="main_footer">
			<footer className="first_part">
				<Container maxWidth="lg" className="footer_container">
					<Grid container justify="space-around" alignItems="center">
						<Grid item>
							<img src="/public/images/logo_siea_blue.svg" />
						</Grid>
						<Grid item>
							<img style={{height: "50px"}} src="/public/images/footerLogo3.svg" />
						</Grid>
					</Grid>
				</Container>
			</footer>
		</div>
	)
}

export default injectIntl(observer(XsFooter))

